
export default {
  accountLogLengths: (state) => state.logLengths,
  accountLengthGroups: (state) => state.lengthGroups,
  accountIdOfLengthGroups: (state) => state.accountIdOfLengthGroups,
  accountDiameterGroups: (state) => state.diameterGroups,
  accountIdOfDiameterGroups: (state) => state.accountIdOfDiameterGroups,
  accountSpeciesGroups: (state) => state.speciesGroups
}
